import router from '../../../router'
import axios from "axios";
import customcfg from './conf'
const _import = require('../../../router/_import_production');
var getRouter;
router.beforeEach((to, from, next) => {
    if(!getRouter){
        const getRoute = localStorage.getItem('routemap');
        if(getRoute && JSON.parse(getRoute)){
            getRouter=JSON.parse(getRoute);
            routerGo(to,next)
        }else{
            RequestApi('get_route.html').then(function (res){
                if(res.status==1){
                    localStorage.setItem('routemap',JSON.stringify(res.route));
                    getRouter=res.route;
                    routerGo(to,next)
                }else{
                    if(to.path==='/login') next();
                    else next({path:'/login'});
                }
            })
        }
    }else{
        next();
    }
})

function routerGo(to, next) {
    filterAsyncRouter(getRouter); //过滤路由
    next({ ...to, replace: true });
}

function filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
    const accessedRouters = asyncRouterMap.filter(route => {
        if (route.component) route.component = _import(route.component);
        route=buildRoute(route);
        router.addRoute(route); //动态添加路由
        return true
    })
    return accessedRouters
}
function RequestApi(url,data,headers){
    let header=Object.assign({'content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},headers);
    return new Promise((resolve) => {
        axios.interceptors.request.use(
            config => {
                const token = localStorage.getItem('qfyutoken');
                token && (config.headers.qfyuauthorize = token);
                return config;
            },error => {
                return Promise.error(error);
            });
        axios({
            method: typeof data == "object" ? 'POST' : 'GET',
            url: customcfg.ApiUrl + customcfg.ApiModule + url,
            data: data ? data : {},
            headers: header,
            responseType: 'json',
        }).then(res => {
            if (res.status == 200) {
                resolve(res.data);
            }
        }).catch(err => {
            console.log(err);
        })
    })
}

/**
 * 检测路由是否有参数 并处理参数
 * @param route
 */

function buildRoute(route){
    if(route.path.indexOf('?')!=-1){
        var patharr=route.path.split('?'),queryarr=patharr[1].split('&');
        route.path=patharr[0];
        if(queryarr[0]){
            route.query={};
            for (var qk in queryarr){
                var query=queryarr[qk].split('=');
                route.query[query[0]]=query[1];
            }
        }
    }
    return route;
}
